import React, { useState } from "react";
import Header from "../../users/header";
import Sidebar from "../../users/sidebar";
import { Box, useMediaQuery } from "@mui/material";
import { CartProvider } from "../../hooks/shareContext";
import AfterLoginFooter from "../../users/footer/afterLoginFooter";
import AuthChecker from "./authChecker";
import { useLocation } from "react-router-dom";

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const isMobile = useMediaQuery("(max-width:820px)");
  const location = useLocation();
  console.log("location", location.pathname)

  const [sidebarOpen, setSidebarOpen] = useState(false);
  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);

  return (
    <CartProvider>
      <AuthChecker />
      <div
        style={{
          display: "flex",
          height: "auto",
          // position: "fixed",
        }}
      >
        {location.pathname === "/loopvideo" ? "" : <Sidebar open={sidebarOpen} toggleSidebar={toggleSidebar} />}

        <div
          style={{
            display: sidebarOpen ? (isMobile ? "flex" : "block") : "block",
            flexDirection: "column",
            width: sidebarOpen ? (isMobile ? "100vw" : "100vw") : "100vw",
            overflowY: isMobile ? "scroll" : "auto",
            scrollbarWidth: "none", // Hide scrollbar for Firefox
            msOverflowStyle: "none", // Hide scrollbar for IE & Edge
          }}
        >
          {location.pathname === "/loopvideo" ? "" : <Header toggleSidebar={toggleSidebar} sidebarOpen={sidebarOpen} />}
          <Box
            sx={{
              margin: sidebarOpen ? "100px 0px" : (isMobile ? "70px 0px" : "100px 0px"), // Push content below the header
              // marginLeft: sidebarOpen ? '20px' : '0' : isMobile ? '20px' : '0',  // Adjust content margin when sidebar is open
              marginLeft: sidebarOpen ? (isMobile ? "" : "270px") : "0", // Adjust content margin when sidebar is open
              transition:
                "margin-left 0.4s ease-in-out, transform 0.4s ease-in-out, width 0.4s ease-in-out",
              flexGrow: 1,
              zIndex: isMobile ? "-99" : "",
              height: "auto",
            }}
          >
            {children}
            <AfterLoginFooter />
          </Box>
        </div>
      </div>
    </CartProvider>
  );
};

export default Layout;
